export default __webpack_public_path__ + "static/media/IMG_20200216_095242-enhance.d8b9bce1.jpg";